module.exports = __webpack_public_path__ + "static/img/4.ff505dc.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/5/eng/4.png
// module id = ARwT
// module chunks = 0